import axios from 'axios';
import _ from 'lodash';
import {
  apiErrorHandler,
  getBaseContentUrl,
  helperGetApiAccountRoute,
  helperGetApiHeaders,
  helperGetApiRoute,
  helperGetApiRouteById,
} from 'helpers/ApiHelper';

export const CLEAR_CONTINUE_WATCHING_CTA = 'CLEAR_CONTINUE_WATCHING_CTA';
export const FETCH_ACTIVE_PLAN_PACKAGES = 'FETCH_ACTIVE_PLAN_PACKAGES';
const FETCH_ACTIVE_PLANS = 'FETCH_ACTIVE_PLANS';
export const FETCH_CONTINUE_WATCHING_CTA = 'FETCH_CONTINUE_WATCHING_CTA';
export const SET_FREEMIUM_MODAL_VISIBILITY = 'SET_FREEMIUM_MODAL_VISIBILITY';
export const SET_MVPD_PROVIDERS = 'SET_MVPD_PROVIDERS';
const MVPD_PROVIDERS_ALREADY_FETCHED = 'MVPD_PROVIDERS_ALREADY_FETCHED';
export const SET_NEXT_MVPD_PROVIDERS_PAGE = 'SET_NEXT_MVPD_PROVIDERS_PAGE';
export const SET_PREAUTHORIZED_RESOURCES = 'SET_PREAUTHORIZED_RESOURCES';
export const SET_RECOMMENDATION_ID = 'SET_RECOMMENDATION_ID';
export const SET_USER_AUTH_DATA = 'SET_USER_AUTH_DATA';
export const REFRESH_USER_AUTH = 'REFRESH_USER_AUTH';
const SDKS_FAILURE = 'SDKS_FAILURE';
export const SET_USER_SUBSCRIPTION = 'SET_USER_SUBSCRIPTION';
const SDKS_UPDATED = 'SDKS_UPDATED';

const setNextMVPDProvidersPage = request => ({
  type: SET_NEXT_MVPD_PROVIDERS_PAGE,
  payload: request,
});

const fetchNextMVPDProvidersPageAction = (url, deviceId) => dispatch => {
  const pageType = 'mvpds';
  axios
    .get(url, helperGetApiHeaders({ pathKey: pageType, deviceId }))
    .then(results => {
      const nextPage = _.get(results, 'data.view.next');
      if (nextPage) dispatch(fetchNextMVPDProvidersPageAction(nextPage, deviceId));
      dispatch(setNextMVPDProvidersPage(results));
    })
    .catch(e => apiErrorHandler({ error: e }));
};

const setMVPDProviders = request => ({
  type: SET_MVPD_PROVIDERS,
  payload: request,
});

export const fetchMVPDProvidersAction = deviceId => async (dispatch, getState) => {
  const { mvpdProviders } = getState().app;
  const pageType = 'mvpds';
  const route = helperGetApiRoute(pageType);
  const headers = helperGetApiHeaders({ pathKey: pageType, deviceId });
  if (mvpdProviders?.length > 0) {
    return {
      type: MVPD_PROVIDERS_ALREADY_FETCHED,
    };
  }
  const results = await axios.get(route, headers).catch(e => apiErrorHandler({ error: e }));
  const nextPage = results?.data?.view?.next;
  if (nextPage) dispatch(fetchNextMVPDProvidersPageAction(nextPage, deviceId));
  return dispatch(setMVPDProviders(results));
};

const setUserSubscription = request => ({
  type: SET_USER_SUBSCRIPTION,
  payload: request,
});

export const fetchUserSubscriptionStatusAction = accessToken => dispatch => {
  const pageType = 'currentSubscriptionStatus';
  axios
    .get(helperGetApiAccountRoute(pageType), helperGetApiHeaders({ accessToken }))
    .then(results => {
      dispatch(setUserSubscription(results));
    })
    .catch(e => apiErrorHandler({ error: e }));
};

export const fetchContinueWatchingAction = ({ id, accessToken, deviceId }) => {
  const pageType = 'videoDetail';
  const request = id
    ? axios
        .get(
          helperGetApiRouteById(pageType, id, '{videoId}'),
          helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }),
        )
        .catch(e => apiErrorHandler({ error: e }))
    : Promise.resolve();

  return {
    type: FETCH_CONTINUE_WATCHING_CTA,
    payload: request,
  };
};

const fetchActivePlans = ({ accessToken, deviceId }) => {
  const pageType = 'activePlans';
  const request = axios.get(
    helperGetApiRoute(pageType),
    helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }),
  );
  return {
    type: FETCH_ACTIVE_PLANS,
    payload: request,
  };
};

const fetchActivePlanPackages = ({ accessToken, deviceId, currentPackages }) => {
  const getPackageUrl = `${getBaseContentUrl()}packages?packageID=${currentPackages.join(',')}`;
  const request = axios.get(getPackageUrl, helperGetApiHeaders({ accessToken, deviceId }));
  return {
    type: FETCH_ACTIVE_PLAN_PACKAGES,
    payload: request,
  };
};

export function fetchCurrentActivePlans(accessToken, deviceId) {
  return dispatch =>
    dispatch(fetchActivePlans(accessToken, deviceId)).then(data => {
      const packageData = data?.payload?.data;
      const currentPackages = [];
      if (packageData) {
        packageData.map(item => currentPackages.push(item.planId));
      } else {
        Promise.resolve();
      }
      dispatch(fetchActivePlanPackages({ accessToken, deviceId, currentPackages }));
    });
}

export function clearContinueWatchingCTA() {
  return {
    type: CLEAR_CONTINUE_WATCHING_CTA,
  };
}

export const setPreauthorizedResourcesAction = (resources = []) => ({
  type: SET_PREAUTHORIZED_RESOURCES,
  payload: resources,
});

export const setRecommendationIdAction = (recommendationId = null) => ({
  type: SET_RECOMMENDATION_ID,
  payload: recommendationId,
});

export const setUserAuthData = data => ({
  type: SET_USER_AUTH_DATA,
  payload: data,
});

export const refreshUserAuth = data => ({
  type: REFRESH_USER_AUTH,
  payload: data,
});

const sdkFailure = accessToken => ({
  type: SDKS_FAILURE,
  payload: accessToken,
});

const sdkSuccess = accessToken => ({
  type: SDKS_UPDATED,
  payload: accessToken,
});

export const setSDKAccessToken = ({ accessToken }) => async (dispatch, getState) => {
  const { profile, profileFavorites, profileBookmarks, auth } = getState().app;
  try {
    await profileBookmarks?.setAccessToken({ accessToken });
    await profileFavorites?.setAccessToken({ accessToken });
    await auth?.setAccessToken({ accessToken });
    await profile?.setAccessToken({ accessToken });
    dispatch(sdkSuccess(accessToken));
  } catch (e) {
    dispatch(sdkFailure(accessToken));
  }
};

export const setFreemiumModalVisibilityAction = ({ visibility, redirectUrl }) => ({
  type: SET_FREEMIUM_MODAL_VISIBILITY,
  payload: { visibility, redirectUrl },
});

export const setEmailSubmissionSFMC = ({ url, email, accessToken, deviceId, platform, cb }) => {
  const headers = helperGetApiHeaders({ accessToken, deviceId });
  const apiUrl = window?.ExternalConfig?.api?.auth?.baseUrl;
  axios
    .post(
      `${apiUrl}prospect`,
      {
        email,
        url,
        prospect: 'foxnation',
        platform,
      },
      headers,
    )
    .then(result => cb(result))
    .catch(error => {
      cb(error);
    });
};
